export default __webpack_public_path__ + "static/media/smarthome.deca3c42.jpg";